import React from 'react';
import clsx from 'clsx';

import './index.scss';

import CheckIcon from 'components/atoms/Icon/CheckIcon';
import StepIcon from 'components/atoms/Icon/StepIcon';

const SpProgress = ({ step, status, titles, hasBar }) => {
  const Icon = {
    done: <CheckIcon color="0" />,
    doing: <StepIcon step={step} doing />,
    todo: <StepIcon step={step} />,
  };

  return (  
    <div className="SpProgress">
      <div className="wrapper">
        {/* タイトル、選択済み項目 */}
        <div className={clsx('title-area', { doing: status === 'doing' })}>
          <div className="title">
            {titles.map(title => (
              <div key={title}>{title}</div>
            ))}
          </div>
        </div>

        {/* アイコン・バー */}
        <div className="icon">
          {hasBar && <div className={clsx('bar', { doing: status === 'doing' })} />}
          {Icon[status]}
        </div>
      </div>
    </div>
  );
};


export default SpProgress;